import { Navigate, Outlet } from "react-router-dom";
import { getLocalValue, LoacalVariables } from "./commonFunctions/CommonFunctions";

interface ProtectedRouteProps {
  allowedRoles?: string[]; // Optional
  isAuthenticated: boolean | null;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles, isAuthenticated }) => {
  if (isAuthenticated === null) return null; // or show loader

  const userType = getLocalValue(LoacalVariables.UserType);

  // Not authenticated
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // If role is not allowed
  if (allowedRoles && !allowedRoles.includes(userType)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
